import React, { Component } from "react";
import { connect } from "react-redux";
import { resultsSort } from "../../actions/searchActions";
import { Container, Row, Col, Spinner, Button, ButtonGroup } from "reactstrap";
import ResultsList from "./ResultsList";
import ResultsByChapterList from "./ResultsByChapterList";
import AggregationsBoxes from "../Aggregations/AggregationsBoxes";

import classes from "./ResultsBoard.module.scss";

class ResultsBoard extends Component {
  constructor(props) {
    super(props);

    this.resultsSortModeHeandler = this.resultsSortModeHeandler.bind(this);
  }
  state = {
    totalResults: this.props.totalResults,
    searchTerm: this.props.searchTerm,
    displaySpinner: false,
    displayByChapter: this.props.displayByChapter
  };

  resultsSortModeHeandler(displayByChapter) {
    if (this.state.displayByChapter !== displayByChapter) {
      this.setState({ displayByChapter: displayByChapter });
      this.props.resultsSort(displayByChapter);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.totalResults) {
      this.setState({ totalResults: nextProps.totalResults });
    }
    if (nextProps.searchTerm && nextProps.updateView) {
      this.setState({ searchTerm: nextProps.searchTerm });
    }
    if (nextProps.displaySpinner || !nextProps.displaySpinner) {
      this.setState({ displaySpinner: nextProps.displaySpinner });
    }
    if (nextProps.displayByChapter || !nextProps.displayByChapter) {
      this.setState({ displayByChapter: nextProps.displayByChapter });
    }
  }

  render() {
    const resultsText =
      this.state.totalResults < 0
        ? "<div>לא נמצאו תוצאות עבור <span style='font-weight: 800 !important'>&quot" +
          this.state.searchTerm +
          "&quot</span></div>"
        : this.state.totalResults === 0
        ? "<div></div>"
        : "<div>נמצאו <span style='font-weight: 800 !important'>" +
          this.state.totalResults +
          " </span>תוצאות עבור <span style='font-weight: 800 !important'>&quot" +
          this.state.searchTerm +
          "&quot</span></div>";
    const sortButtons =
      this.state.totalResults > 0 ? (
        <Col className={classes.totalsText} xl="4" lg="6">
          הצג תוצאות לפי:
          <ButtonGroup size="sm" className={"pt-2 mr-2"}>
            <Button
              className={
                this.props.displayByChapter
                  ? classes.chapterButtonSelected
                  : classes.chapterButton
              }
              onClick={() => this.resultsSortModeHeandler(true)}
              active={this.props.displayByChapter}
            >
              פרקים
            </Button>
            <Button
              className={
                this.props.displayByChapter
                  ? classes.chapterButton
                  : classes.chapterButtonSelected
              }
              onClick={() => this.resultsSortModeHeandler(false)}
              active={!this.props.displayByChapter}
            >
              המלצת מנוע החיפוש
            </Button>
          </ButtonGroup>
        </Col>
      ) : (
        ""
      );
    const toReturn = this.state.displaySpinner ? (
      <Container>
        <Row>
          <Col sm="12" className={classes.spinnerCol}>
            <Spinner className={classes.spinner} />
          </Col>
        </Row>
      </Container>
    ) : (
      <Container>
        <Row>
          <AggregationsBoxes />
        </Row>
        <Row className="py-3">
          <Col
            className={classes.totalsText}
            xl={{ size: 3, offset: 5 }}
            lg="6"
          >
            <div dangerouslySetInnerHTML={{ __html: resultsText }} />
          </Col>
          {sortButtons}
        </Row>
        <Row>
          <Col>
            {this.state.displayByChapter ? (
              <ResultsByChapterList />
            ) : (
              <ResultsList />
            )}
            ;
          </Col>
        </Row>
      </Container>
    );

    return toReturn;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resultsSort: displayByChapter => dispatch(resultsSort(displayByChapter))
  };
};

const mapStateToProps = state => {
  return {
    totalResults: state.searchData.totalResults,
    searchTerm: state.searchData.searchTerm,
    updateView: state.searchData.updateView,
    displaySpinner: state.searchData.displaySpinner,
    displayByChapter: state.searchData.displayByChapter
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultsBoard);
